const INITIAL_STATE = {
    requesting: false,
    files: false,
    fileType: "",
    folders: false
};

export const createReducers = actionTypes => {
    return (state = INITIAL_STATE, action) => {
        switch (action.type) {
            case actionTypes.GET_ALL_FILE_MANAGER_FILES.REQUEST: {
                return { ...state, requesting: true, files: false };
            }
            case actionTypes.GET_ALL_FILE_MANAGER_FILES.FAIL: {
                return { ...state, requesting: false, files: false };
            }
            case actionTypes.GET_ALL_FILE_MANAGER_FILES.SUCCESS: {
                return { ...state, requesting: false, files: action.payload };
            }
            case actionTypes.SET_FILE_TYPE: {
                return { ...state, fileType: action.payload };
            }
            case actionTypes.GET_FOLDERS.REQUEST: {
                return { ...state, requesting: true, folders: false };
            }
            case actionTypes.GET_FOLDERS.FAIL: {
                return { ...state, requesting: false, folders: false };
            }
            case actionTypes.GET_FOLDERS.SUCCESS: {
                return { ...state, requesting: false, folders: action.payload };
            }
            default: {
                return { ...state };
            }
        }
    };
};
export default createReducers;
